import React from "react";

const MurfReaderIllustration = (): React.ReactNode => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="80"
      fill="none"
      viewBox="0 0 80 80"
    >
      <g filter="url(#filter0_f_2495_1000)">
        <circle cx="40" cy="40" r="13.845" fill="#C516E1"></circle>
      </g>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2.245"
        d="M28.18 42.893v4.676m4.728-6.939v9.202m4.728-14.482v19.762m4.728-16.745v13.728m4.834-9.202v4.676m4.621-6.939v9.202"
      ></path>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M57.4 17.419H22.6c-2.876 0-4.844.004-6.32.202-1.424.192-2.107.532-2.578 1.004-.472.47-.812 1.154-1.004 2.577-.198 1.477-.202 3.445-.202 6.32v24.956c0 2.875.004 4.843.202 6.32.192 1.423.532 2.106 1.004 2.578.47.47 1.154.812 2.577 1.003 1.477.198 3.445.202 6.32.202h34.802c2.875 0 4.843-.004 6.32-.202 1.423-.191 2.106-.532 2.577-1.003.472-.472.812-1.155 1.004-2.578.198-1.477.202-3.445.202-6.32V27.522c0-2.875-.004-4.843-.203-6.32-.19-1.423-.531-2.106-1.003-2.578-.47-.47-1.154-.811-2.577-1.003-1.477-.198-3.445-.202-6.32-.202m-45.021-.117c-1.754 1.753-1.754 4.576-1.754 10.22v24.956c0 5.645 0 8.467 1.754 10.22 1.753 1.754 4.576 1.754 10.22 1.754h34.802c5.644 0 8.467 0 10.22-1.753 1.754-1.754 1.754-4.576 1.754-10.221V27.522c0-5.644 0-8.467-1.754-10.22-1.753-1.754-4.576-1.754-10.22-1.754H22.599c-5.644 0-8.467 0-10.22 1.754"
        clipRule="evenodd"
      ></path>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M68.627 28.27H11.373V26.4h57.254z"
        clipRule="evenodd"
      ></path>
      <circle cx="16.878" cy="21.998" r="1.301" fill="currentColor"></circle>
      <circle cx="20.955" cy="21.998" r="1.301" fill="currentColor"></circle>
      <circle cx="25.031" cy="21.998" r="1.301" fill="currentColor"></circle>
      <defs>
        <filter
          id="filter0_f_2495_1000"
          width="73.268"
          height="73.268"
          x="3.366"
          y="3.366"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feBlend
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          ></feBlend>
          <feGaussianBlur
            result="effect1_foregroundBlur_2495_1000"
            stdDeviation="11.395"
          ></feGaussianBlur>
        </filter>
      </defs>
    </svg>
  );
};

export default MurfReaderIllustration;
